/**
 * @file color legend component
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {maxSpeed, speedStep, colorScale} from './lib/scale';
const div = React.createFactory('div');

class ColorLegend extends Component {
    render() {
        const {sequentialColorScale} = this.props;
        const colorSteps = [];
        for (let speed = 0; speed <= maxSpeed; speed+=speedStep) {
            colorSteps.push([speed, colorScale(speed, sequentialColorScale)]);
        }
        return div(
            {
                className: 'ColorLegend'
            },
            div(
                {
                    className: 'ColorLegend__scale'
                },
                ...colorSteps.map(([speed, backgroundColor]) => {
                    return div({
                        style: {backgroundColor},
                        className: 'ColorLegend__color-step'
                    })
                })
            ),
            div(
                {
                    className: 'ColorLegend__labels'
                },
                ...colorSteps.map(([speed], i) => {
                    return div(
                        {
                            className: 'ColorLegend__label'
                        },
                        (speed)
                    )
                })
            )
        )
    }
}

export default connect(({styleParamName, sequentialColorScale}, props) => {
    return {styleParamName, sequentialColorScale};
})(ColorLegend);



// WEBPACK FOOTER //
// ./src/ColorLegend.js